import { environment } from '../../../environments/environment';

import type { NgxsModuleOptions } from '@ngxs/store';

export const NGXS_CONFIG: NgxsModuleOptions = {
  developmentMode: !environment.production,
  selectorOptions: {
    suppressErrors: false
  }
};
